<form [formGroup]="offerForm" class="checkbox-form checkbox-control">
  <se-fe-button
    seFeDataEmphasis="medium"
    [seFeDataFullWidth]="true"
    (click)="addToCartClicked()"
    class="cart-button">
    <span class="cart-icon-text">Add to my cart</span>
  </se-fe-button>
  <div class="disclaimer-display">
    <se-fe-checkbox
      id="chk_agreement"
      class="disclaimer-display__checkbox"
      [ngClass]="{'disclaimer-display__error': showFormError}"
      [attr.aria-describedby]="showFormError ? 'chk_agreement_error' : null"
      [seFeDataOptions]="checkboxOptions"
      formControlName="addItemToCart">
      <ng-template seFeFormFieldLabel>
        <span
          class="disclaimer-display__label"
          [innerHTML]="agreementLabel"></span>
      </ng-template>
    </se-fe-checkbox>
    @if (showFormError) {
      <div
        id="chk_agreement_error"
        class="error-message form-control__error-message">
        Check this box to acknowledge you agree to the terms and conditions.
      </div>
    }
  </div>
</form>
